import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F05252",
      d: "M10 0a10 10 0 1 0 10 10A10.01 10.01 0 0 0 10 0m0 15a1 1 0 1 1 0-2.001A1 1 0 0 1 10 15m1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0z"
    }, null, -1)
  ])))
}
export default { render: render }